import firebase from 'firebase/app';
import 'firebase/auth';        // for authentication
import 'firebase/storage';     // for storage
import 'firebase/database';    // for realtime database
import 'firebase/firestore';   // for cloud firestore
import 'firebase/messaging';   // for cloud messaging
import 'firebase/functions';   // for cloud functions

var firebaseConfig = {
    apiKey: "AIzaSyB69Jqelq-UgS2WhVULxAKteNOgVAjWKHs",
    authDomain: "dvl-designs-portfolio.firebaseapp.com",
    databaseURL: "https://dvl-designs-portfolio-default-rtdb.europe-west1.firebasedatabase.app/",
    projectId: "dvl-designs-portfolio",
    storageBucket: "dvl-designs-portfolio.appspot.com",
    appId: ""
};

const fireB = firebase.initializeApp(firebaseConfig);

const auth = fireB.auth();
const db = fireB.firestore();
const storage = fireB.storage();

export default fireB;
export { auth, db, storage };